import { FormUiModifier, FormValue, FormVisualModifier, Effect, FormEffectsDirector } from '@truvity/widget__forms';

export const disableViewOnlyForm: FormEffectsDirector<FormValue> = (builder) => {
    builder.getMutatedFieldsPaths().forEach((fieldPath) => {
        const mutationState = builder.getFieldState(fieldPath);

        /**
         * If fields hidden with specifics, we don't want to change that because
         * UI specifics will take precedence.
         */
        if (
            mutationState &&
            mutationState.ui !== FormUiModifier.Readonly &&
            mutationState.visual !== FormVisualModifier.Invisible &&
            mutationState.visual !== FormVisualModifier.Disabled
        ) {
            builder.set(fieldPath, Effect.DISABLED);
        }
    });
};
